import React from "react";

const variants = {
  success: "badge-success",
  warning: "badge-warning",
  error: "badge-error",
  info: "badge-info",
  neutral: "badge-neutral",
};

const StatusBadge = ({ variant = "neutral", children, dot = true, testid }) => {
  const cls = variants[variant] || variants.neutral;
  return (
    <span className={cls} data-testid={testid}>
      {dot && (
        <span
          className="h-1.5 w-1.5 rounded-full"
          style={{ backgroundColor: "currentColor" }}
        />
      )}
      {children}
    </span>
  );
};

export default StatusBadge;
